import React from 'react';
import { DataTable, useThemedValueSwitch } from '@tq/ui-components';
import { useTranslation } from 'react-i18next';

import { KpiLateResponse } from 'types';
import { useKpiTableRowTranslations } from '../hooks';

export type KpiTableDataProps = {
  lateResponses: KpiLateResponse[];
};

export const KpiTableCard: React.FC<KpiTableDataProps> = ({ lateResponses }) => {
  const { t } = useTranslation('annual_dfi_report');
  const translatedResponses = useKpiTableRowTranslations(lateResponses);

  const { isTQ } = useThemedValueSwitch();

  const translatedResponsesText = isTQ
    ? t('tqen_late_response', 'Principle reason for responses issued beyond the deadline')
    : t(
        'late_response',
        'Principle reason for responses issued beyond the statutory deadline'
      );

  return (
    <DataTable
      data={translatedResponses ?? []}
      columns={[
        {
          Header: translatedResponsesText,
          accessor: 'lateResponseReason',
          width: 'auto',
        },
        {
          Header: () => t('number', 'Number'),
          accessor: 'lateResponseReasonCount',
          width: 'min-content',
        },
        {
          Header: () => t('percentage_header', 'Percentage (of total no. late responses)'),
          accessor: 'lateResponseReasonPercentage',
          width: 'min-content',
          Cell: (cellProps: { value: string }) => cellProps.value + '%',
        },
      ]}
      size='sm'
      disableSortRemove
      disablePagination
    />
  );
};
